/** Specifies the project stylesheets types */
export enum ProjectStylesheetType {
  /** General stylesheet */
  General = "general",
  /** Branding stylesheet */
  Branding = "branding",
  /** Table stylesheet */
  Table = "table",
}
